/**
 * Returns true if column is ListIconColumnProps.
 * @param column the column
 * @returns whether the column is the icon column
 */
export const isIconColumn = column => 'cellIcon' in column || 'cellHelpPopup' in column || 'cellMenuButton' in column;
//# sourceMappingURL=typeguards.js.map